import type { TenantConfig } from './types';
import { defaultConfig } from './default';

/**
 * PepsiCo tenant configuration
 */
export const pepsicoConfig: TenantConfig = {
  ...defaultConfig,
  id: 'pepsico',
  name: 'PepsiCo',
  branding: {
    logo: '/Images/wint-pepsico-logo.png',
    logoSmall: '/Images/wint-pepsico-logo-small.png',
    favicon: '/favicon.ico',
    primaryColor: '#004B93', // PepsiCo blue
    secondaryColor: '#E32526', // PepsiCo red
    companyName: 'PepsiCo',
  },
  terminology: {
    ...defaultConfig.terminology,
    line: 'Line',
    lines: 'Lines',
  },
  features: {
    ...defaultConfig.features,
    weeklyTrend: false, // Disabled for PepsiCo
    valveStatus: false,
    shiftReport: false,
  },
  defaults: {
    ...defaultConfig.defaults,
    unitSystem: 'metric',
    timezone: 'Europe/Brussels',
    dateFormat: 'MMM d, yyyy',
    dateTimeFormat: 'MMM d, yyyy HH:mm',
  },
  routes: {
    ...defaultConfig.routes,
    weeklyTrend: false,
    valveStatus: false,
    shiftReport: false,
  },
  // Metric units for PepsiCo
  unitLabels: {
    volume: 'L',
    volumeLarge: '㎥',
    flowRate: 'L/h',
    temperature: '°C',
    duration: 'min',
  },
  conversionFactors: {
    litersToVolume: 1,
    litersToVolumeLarge: 0.001, // Liters to cubic meters
    flowRateConversion: 1,
    temperatureConversion: (celsius: number) => celsius,
  },
};







